import { useState } from "react";
import { Link } from "react-router-dom";
//-------------------------------------------------
import {
    myAxios,
    numberReducer,
    onlyUnique, 
    defaultPath
} from "src/components/common/functions";
//-------------------------------------------------
type data = {matches: string[], path: string, lines: number, pos: number}[];
export default function Search(){
    // replace
    // add search and options to url params
    //-------------------------------------------------
    const [rootPath, setRootPath] = useState(`${defaultPath}/test`);
    const [data, setData] = useState<data>([]);
    const [showLoading, setShowLoading] = useState(false);
    const [search, setSearch] = useState({autocomplete: false, caseSensitive: false, wholeWord: false, needle: ""});
    //-------------------------------------------------
    const handleSearch = async() => {
        //------------------------
        setShowLoading(true);
        const formData = new FormData();
        formData.append("rootPath", rootPath);
        formData.append("autocomplete", String(search.autocomplete));
        formData.append("caseSensitive", String(search.caseSensitive));
        formData.append("wholeWord", String(search.wholeWord));
        formData.append("needle", search.needle);
        const res = await myAxios({ fileName: "server/search.php", formData: formData });
        setShowLoading(false);
        if(!res) return;
        //------------------------
        setData(res.data);
    }
    return (
        <div className = "cssContent pb8rem">
            <nav className = "d-flex align-items-center mt-2 mb-4">
                <span className = "toolbar_item d-inline-flex align-items-center me-3">
                    <label
                        children = "Search:"
                        htmlFor = "search"
                        className = "me-2"
                    />
                    <input
                        id = "search"
                        className = "form-control inline w-auto"
                        type = "text"
                        value = {search.needle}
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            setSearch(search => ({
                                ...search, 
                                needle: value
                            }));
                        }}
                        onKeyDown = {e => {
                            if(e.key === "Enter"){
                                handleSearch();      
                            }
                        }}
                    />
                </span>
                <span className = "toolbar_item d-inline-flex align-items-center me-3">
                    <label htmlFor = "path">Path:</label>
                    <select
                        id = "path"
                        className = "form-control inline w-auto ms-2"
                        value = {rootPath}
                        onChange = {e => {
                            setRootPath(e.currentTarget.value)
                        }}
                    >
                        <option value = {`${defaultPath}/test`}>Construct Smarter</option>
                        <option value = {""}>All</option>
                    </select>
                </span>
                <span className = "toolbar_item d-inline-flex align-items-center me-3">
                    <label htmlFor = "matchCase">Match Case:</label>
                    <input
                        id = "matchCase"
                        type = "checkbox"
                        className = "cssCheckBox ms-2"
                        checked = {search.caseSensitive}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            setSearch(search => ({
                                ...search,
                                caseSensitive: checked
                            }))
                            
                        }}
                    />
                </span>
                <span className = "toolbar_item d-inline-flex align-items-center me-3">
                    <label htmlFor = "autoComplete">AutoComplete:</label>
                    <input
                        id = "autoComplete"
                        type = "checkbox"
                        className = "cssCheckBox ms-2"
                        checked = {search.autocomplete}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            setSearch(search => ({
                                ...search,
                                autocomplete: checked,
                                wholeWord: checked? false : search.wholeWord
                            }))
                            
                        }}
                    />
                </span>
                <span className = "toolbar_item d-inline-flex align-items-center me-3">
                    <label htmlFor = "matchWholeWord" className = "ms-3 mb-0">Match Whole Word:</label>
                    <input
                        id = "matchWholeWord"
                        type = "checkbox"
                        className = "cssCheckBox ms-2"
                        checked = {search.wholeWord}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            setSearch(search => ({
                                ...search,
                                wholeWord: checked,
                                autocomplete: checked? false : search.autocomplete
                            }))
                        }}
                    />
                </span>

                {search.needle?
                 <span className = "toolbar_item d-inline-flex align-items-center me-3">
                    <button
                        type = "button"
                        children = "Submit"
                        className = "btn btn-primary"
                        onClick = {handleSearch}
                    />
                </span>
                :<></>}
            </nav>
            {showLoading?<div className = "cssLoading">Loading...</div>:
            !data.length?<div className = "cssLoading">Empty</div>:
            <div>
                {data.length?
                <h3 className = "text-info">
                    Found {search.autocomplete?data.map(d => d.matches?.length ?? 0).reduce(numberReducer, 0):data.length} result(s) in {data.map(d => d.path).filter(onlyUnique).length} file(s)
                </h3>
                :<></>}
                {data.map(d => d.path).filter(onlyUnique).map((path, pathIndex) => 
                <div key = {pathIndex} className = "my-4">
                    <Link to = {`/FileExplorer?path=${path}&searchQuery=${search.needle}`} className = "h4" style = {{wordBreak: "break-all"}}>{path}</Link>
                    <span className = "h5 text-success ms-2">{search.autocomplete?data.find(d => d.path === path)?.matches?.length ?? 0:data.filter(d => d.path === path).length} result(s)</span>
                    {data.filter(d => d.path === path).map((item, itemIndex) => 
                    <h5 key = {itemIndex}>
                        {search.autocomplete?
                        <>{item.matches?.map((match, matchIndex) => <li key = {matchIndex}>{match}</li>)}</>:
                        <li><span className = "text-secondary">{itemIndex + 1}.</span> lines: {item.lines} : {item.pos}</li>}
                    </h5>)}
            </div>)}
            </div>}
        </div>
    )
}